import { connect } from "react-redux";
import * as actions from "./actions";

function mapStateToProps(state) {
  return { settings: state.settings };
}

function mapDispatchToProps(dispatch) {
  return {
    getUserData: () => {
      dispatch(actions.fetch_user_data());
    },
    setSessionMinutes: (minutes) => {
      dispatch(actions.set_session_minutes(minutes));
    },
    refreshToken: () => {
      dispatch(actions.refresh_token());
    },
  };
}

export const settingsConnector = connect(mapStateToProps, mapDispatchToProps);
